import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

import { WithThemeProps } from '../../../styles';


const GlobalStyle = createGlobalStyle`
	html {
		${(p: WithThemeProps) => p.theme && `
			font-size: ${p.theme.typography.baseFontSize}px;
			color: ${p.theme.color.blackPrimary};
		`};
	}

	body {
		${(p: WithThemeProps) => p.theme && `
			${p.theme.typography.body.styled}
			background-color: ${p.theme.color.bgLight}
		`};
	}
`;

const Root = styled.div`
	width: 100%;
	height: auto;
	min-height: 100vh;
	display: flex;
	flex-flow: column nowrap;
`;

const HeaderLayout = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
	z-index: 1000;
`;

const ContentLayout = styled.div`
	flex: 1 1 auto;
	position: relative;
	width: 100%;
	height: auto;
	display: flex;
	flex-flow: row nowrap;
	align-items: stretch;
	overflow-x: hidden;
`;

const SidebarLayout = styled.div`
	position: fixed;
	top: 70px;
	left: 0;
	bottom: 0;
	width: 80px;
	display: flex;
	align-items: stretch;
	z-index: 100;
`;

const RoutingLayout = styled.div`
	width: calc(100% - 80px);
	flex: 1 1 auto;
	position: relative;
	display: flex;
	align-items: stretch;
	margin-top: 70px;
	margin-left: 80px;
`;

const Base = {
	GlobalStyle,
	Root,
	HeaderLayout,
	ContentLayout,
	SidebarLayout,
	RoutingLayout,
};

export default Base;
